import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import HtmlAppletForm from './HtmlAppletForm';
import { useNavigate, useParams } from 'react-router';
import useCheckPermission from '../../hooks/useCheckPermission';
import htmlAppletService from '../../services/htmlAppletService';

const HtmlAppletEdit = () => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const params = useParams();
  const [errors, setErrors] = useState<string[]>([]);

  const [entity, setEntity] = useState<any>({
    id: '',
    name: '',
    htmlContent: '',
    contentUrl: null,
    packageUrl: null,
  });

  const { checkPermission } = useCheckPermission();

  useEffect(() => {
    dispatch({ type: 'SHOW_QUERY' });
    htmlAppletService
      .get(params.id)
      .then((response: any) => {
        if (response.hasError) {
          setErrors(response.errorMessages ?? ['Ismeretlen hiba']);
          enqueueSnackbar((response.errorMessages ?? []).join(','), {
            variant: 'error',
          });
        } else {
          const result = response.result ?? {};
          setEntity({
            ...result,
            htmlContent: result.htmlContent ?? '',
          });
        }
      })
      .catch((err) => {
        const message =
          err?.response?.data?.title ||
          err?.message ||
          'Betöltés sikertelen';
        enqueueSnackbar(message, { variant: 'error' });
      })
      .finally(() => dispatch({ type: 'HIDE' }));
  }, [params.id]);

  const onSubmit = (formEntity: any, setSubmitting: any) => {
    dispatch({ type: 'SHOW_SAVE' });
    htmlAppletService
      .update({
        id: formEntity.id,
        name: formEntity.name,
        htmlContent: formEntity.htmlContent,
        file: formEntity.file,
        responsibilityAccepted: formEntity.responsibilityAccepted,
      })
      .then((response) => {
        if (response.hasError) {
          setErrors(response.errorMessages ?? ['Ismeretlen hiba']);
          enqueueSnackbar((response.errorMessages ?? []).join(','), {
            variant: 'error',
          });
        } else {
          enqueueSnackbar('Sikeres mentés!', {
            variant: 'success',
          });

          navigate('/htmlApplets');
        }
      })
      .catch((err) => {
        const message =
          err?.response?.data?.title ||
          err?.response?.data?.detail ||
          err?.message ||
          'Mentés sikertelen';
        setErrors([message]);
        enqueueSnackbar(message, { variant: 'error' });
      })
      .finally(() => {
        dispatch({ type: 'HIDE' });
        if (setSubmitting) setSubmitting(false);
      });
  };

  return (
    <HtmlAppletForm
      entity={entity}
      readonly={!checkPermission(['EditHtmlApplet'])}
      onSubmit={onSubmit}
      handleCancel={() => navigate('/htmlApplets')}
      errors={errors}
    />
  );
};

export default HtmlAppletEdit;
